module.exports = __webpack_public_path__ + "img/tech2.8775e035.webp";